export const environment = {
    production: false,
    // domain: 'https://gchdwmteuswap02pythonapi.azurewebsites.net', //dev old
    domain: 'https://ppatool-dev-api.genpact.com', //dev new

    // ppa: 'https://gchdwmteuswap02pythonapi.azurewebsites.net' //dev old 
    ppa: 'https://ppatool-dev-api.genpact.com' //dev

};
